import { SpherePlatformApp } from '@sphere/platform';
import { appRoute } from './na-power-markets';
import { PATHS } from './na-power-markets.paths';

export const NAPowerMarketsApp: SpherePlatformApp = {
    APP: appRoute,
    PATHS
};
